export enum ESettingsPaths {
  Base = "settings",
  TenantProfile = "tenant-profile",
  RentmatchScore = "score",
  TenantProfileNotifications = "tenant-profile-notifications",
  TemplatePreferences = "template-preferences",
  Communication = "communication",
  ChecklistPreferences = "checklist-preferences",
  LatePaymentPenaltyPreferences = "late-payment-penalty",
}
